import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export const AccessDenied = () => {
  const { logout, userEmail } = useAuth();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '1rem',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        width: '100%',
        maxWidth: '480px',
        padding: '2rem',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚫</div>
        <h1 style={{ fontSize: '1.5rem', color: '#333', marginBottom: '0.5rem' }}>
          Access Denied
        </h1>
        <p style={{ color: '#666', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          Your account <strong>{userEmail}</strong> is not on the approved access list.
        </p>
        <p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          This application is restricted to pre-approved users only.
          Please contact the administrator to request access.
        </p>
        <button
          onClick={logout}
          style={{
            padding: '0.75rem 2rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;


